// extracted by mini-css-extract-plugin
module.exports = {"small-horizontal-card":"small-horizontal-card-m__small-horizontal-card__QBjYD"};